import { useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import './fullCalendar.css';

function formatDate(dateStr) {
  if (!dateStr) return null;
  return new Date(dateStr).toLocaleString(undefined, {
    weekday: "long", year: "numeric", month: "long",
    day: "numeric", hour: "2-digit", minute: "2-digit",
  });
}

function EventModal({ event, onClose }) {
  if (!event) return null;
  const start = formatDate(event.start);
  const end = formatDate(event.end);

  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0,
      background: "rgba(0,0,0,0.55)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 1000,
      backdropFilter: "blur(4px)",
    }}>
      <div onClick={(e) => e.stopPropagation()} style={{
        background: "var(--bg)",
        borderRadius: 32,
        padding: "48px",
        width: 400,
        display: "flex",
        flexDirection: "column",
        gap: 24,
        boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
        fontFamily: "Outfit",
      }}>

        <div style={{
          height: 4, borderRadius: 4,
          background: "var(--primary)",
        }} />

        <h2 style={{
          margin: 0,
          fontSize: 28,
          fontFamily: "SaintRegus",
          color: "var(--primary)",
          lineHeight: 1,
        }}>
          {event.title}
        </h2>

        <button onClick={onClose} style={{
          height: 58,
          borderRadius: 100,
          border: "none",
          background: "var(--primary)",
          color: "var(--bg)",
          fontFamily: "Outfit",
          fontSize: 16,
          cursor: "pointer",
          transition: "0.3s ease",
        }}>
          Close
        </button>

      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div style={{ display: "flex", gap: 12, fontSize: 15 }}>
      <span style={{
        minWidth: 52,
        fontWeight: 600,
        color: "var(--primary)",
        opacity: 0.7,
      }}>
        {label}
      </span>
      <span style={{ color: "var(--primaryText)" }}>{value}</span>
    </div>
  );
}

export default function CalendarApp() {
  const [events] = useState([
    { id: "1",  title: "Opening Day",         date: "2027-01-25", backgroundColor: "#AD4D34", borderColor: "#AD4D34" },
    { id: "2",  title: "Author Signing",       date: "2027-01-26", backgroundColor: "#AD4D34", borderColor: "#AD4D34" },
    { id: "3",  title: "Children's Workshop",  date: "2027-01-27", backgroundColor: "#AD4D34", borderColor: "#AD4D34" },
    { id: "4",  title: "Panel Discussion",     date: "2027-01-28", backgroundColor: "#AD4D34", borderColor: "#AD4D34" },
    { id: "5",  title: "Poetry Night",         date: "2027-01-29", backgroundColor: "#AD4D34", borderColor: "#AD4D34" },
    { id: "6",  title: "Book Club Meetup",     date: "2027-01-30", backgroundColor: "#AD4D34", borderColor: "#AD4D34" },
    { id: "7",  title: "Photography Exhibit",  date: "2027-01-31", backgroundColor: "#AD4D34", borderColor: "#AD4D34" },
    { id: "8",  title: "Cultural Night",       date: "2027-02-01", backgroundColor: "#AD4D34", borderColor: "#AD4D34" },
    { id: "9",  title: "Science & Tech Talk",  date: "2027-02-02", backgroundColor: "#AD4D34", borderColor: "#AD4D34" },
    { id: "10", title: "Live Music Session",   date: "2027-02-03", backgroundColor: "#AD4D34", borderColor: "#AD4D34" },
    { id: "11", title: "Art Workshop",         date: "2027-02-04", backgroundColor: "#AD4D34", borderColor: "#AD4D34" },
    { id: "12", title: "Film Screening",       date: "2027-02-05", backgroundColor: "#AD4D34", borderColor: "#AD4D34" },
    { id: "13", title: "Storytelling Session", date: "2027-02-06", backgroundColor: "#AD4D34", borderColor: "#AD4D34" },
    { id: "14", title: "Closing Ceremony",     date: "2027-02-07", backgroundColor: "#AD4D34", borderColor: "#AD4D34" },
  ]);

  const [selectedEvent, setSelectedEvent] = useState(null);

  const handleEventClick = (info) => {
    setSelectedEvent({
      title: info.event.title,
      start: info.event.startStr,
      end: info.event.endStr,
      backgroundColor: info.event.backgroundColor,
      extendedProps: info.event.extendedProps,
    });
  };

  return (
    <>
      <EventModal event={selectedEvent} onClose={() => setSelectedEvent(null)} />
      <div style={{ maxWidth: 900, margin: "2rem auto", padding: "0 1rem" }}>
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          initialDate="2027-01-01"
          validRange={{ start: "2027-01-01", end: "2027-02-28" }}
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth",
          }}
          events={events}
          eventClick={handleEventClick}
          height="auto"
        />
      </div>
    </>
  );
}